// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"72853b70","222":"72853b70","251":"b8b0606c","424":"6fb6040f","429":"7bf75a81","435":"023ed5c6","470":"b7a35405","554":"f0632630","667":"01ae27d0","829":"3b8b36ad","922":"15f9f0c6","956":"37873cd0"}[chunkId] + ".chunk.css";
};